<script setup lang="ts"></script>

<template>
  <div
    class="w-full h-[48px] flex items-center justify-between rounded-[4px] my-[2px] p-3 bg-[#E5E4E2]"
  >
    <!-- Left side -->
    <div>
      <slot name="header-left" />
    </div>
    <!-- Right side -->
    <div class="flex items-center justify-end">
      <slot name="header-right" />
    </div>
  </div>
</template>
